import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from '../gsap-club/gsap-business-green/src/CustomEase';
import { SplitText } from '../gsap-club/gsap-business-green/src/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );

/* eslint-disable */
( function ($) {
	let mm = gsap.matchMedia();

	mm.add( {
		isMin0: '(min-width: 0px)',
		isMax768: '(max-width: 768px)',
		reduceMotion: '(prefers-reduced-motion: reduce)',
	},
	( context ) => {
		// context.conditions has a boolean property for each condition defined above indicating if it's matched or not.
		let { isMin0, isMax768, reduceMotion } = context.conditions;
		const hasChildItems = $('#secondary-footer-menu .menu-item-has-children');

		if (isMax768) {

			hasChildItems.each( function() {
				const link = $(this).find('a').first();
				const toggle = $(this).find('.menu-item-toggle');
				if (!toggle.length) {
					$(`<span class="menu-item-toggle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 8.79289C5.65338 8.43241 6.22061 8.40468 6.6129 8.7097L6.70711 8.79289L12 14.085L17.2929 8.79289C17.6534 8.43241 18.2206 8.40468 18.6129 8.7097L18.7071 8.79289C19.0676 9.15338 19.0953 9.72061 18.7903 10.1129L18.7071 10.2071L12.7071 16.2071C12.3466 16.5676 11.7794 16.5953 11.3871 16.2903L11.2929 16.2071L5.29289 10.2071C4.90237 9.81658 4.90237 9.18342 5.29289 8.79289Z" fill="#F0EFEB"/></svg></span>`).insertAfter(link);
				}

				const subMenu = $(this).find('.sub-menu');
				subMenu.css('display', 'none')

			} );

		} else {
			hasChildItems.each(function() {
				const subMenu = $(this).find('.sub-menu');
				$(this).removeClass('menu-item--active');
				subMenu.css('display', 'block');
			});
		}
	});

	$('.menu-item-toggle').on('click', function() {
		//toggle active parent class
		$(this).parent().toggleClass('menu-item--active');
		$(this).next('.sub-menu').slideToggle('300');
	});
} )(jQuery);
/* eslint-enable */
